var isElementHidden = function isElementHidden(element) {
  if (getComputedStyle(element).visibility === 'hidden') {
    return true;
  }

  var ancestorSearchNode = element;

  while (ancestorSearchNode) {
    if (getComputedStyle(ancestorSearchNode).display === 'none') {
      return true;
    }

    ancestorSearchNode = ancestorSearchNode.parentElement;
  }

  return false;
};

export default isElementHidden;